import type { PageBodyStepper } from "@Light/components/page/PageBody";
import { EnrollRoute } from "../routes";
import { useEnrollment } from "./context";
import { stepperFor } from "./stepper";

/**
 * Provides the ``PageBodyStepper`` value for the screen at `route`, counting the
 * steps the customer has after the rate. Undefined on and before the rate.
 */
export function useEnrollmentStepper(
  route: EnrollRoute,
): PageBodyStepper | undefined {
  const { screens, initialRequirements, requirements } = useEnrollment();
  return stepperFor(
    route,
    EnrollRoute.ConfirmRate,
    screens,
    initialRequirements,
    requirements,
  );
}
